import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { IconButton } from "@atoms"

import styles from "./TopBarSearchButton.module.scss"
import { TopBarSearchButtonProps } from "./TopBarSearchButton.types"

export default function TopBarSearchButton(props: TopBarSearchButtonProps) {
    const { scope } = props

    const isDesktop = useIsDesktop()

    const onClick = () => {
        const openSearchModal = new CustomEvent("openSearchModal", {
            detail: {
                scope,
            },
        })
        window.dispatchEvent(openSearchModal)
    }

    if (!isDesktop) {
        return null
    }

    return (
        <IconButton
            size="lg"
            variant="ghost"
            className={styles.base}
            icon={faIcon({ name: "magnifying-glass", style: "regular" })}
            onClick={onClick}
            aria-label="Open search"
            noDebounce={true}
        />
    )
}
